export default __webpack_public_path__ + "static/media/auth_technological.ae2b33f7.svg";